import type { SiteInspectionItem, DiaryEntryForSiteInspection } from "../../../../hooks/useProjectSiteInspections";
import type { DiaryEntryItem } from "./DiaryEntryCard";
import SiteInspectionSection from "./SiteInspectionSection";
import EmptyVisitasState from "./EmptyVisitasState";

export interface SiteInspectionsProps {
  siteInspections: SiteInspectionItem[];
  hasNextPage?: boolean;
  onLoadMore?: () => void;
  isAdmin?: boolean;
  currentUserId?: string | null;
  projectId?: string;
  onFileVisibilityChange?: () => void;
  onAddFirstVisita?: () => void;
  addVisitaLoading?: boolean;
  onAddEntry: (visita: SiteInspectionItem) => void;
  onDeleteVisita?: (visita: SiteInspectionItem) => void;
  onEditEntry: (entry: DiaryEntryItem) => void;
  onDeleteEntry: (entry: DiaryEntryItem) => void;
  onUploadEntry?: (entry: DiaryEntryItem) => void;
  toDiaryEntryItem: (entry: DiaryEntryForSiteInspection) => DiaryEntryItem;
}

export default function SiteInspections({
  siteInspections,
  hasNextPage = false,
  onLoadMore,
  isAdmin = false,
  currentUserId,
  projectId,
  onFileVisibilityChange,
  onAddFirstVisita,
  addVisitaLoading = false,
  onAddEntry,
  onDeleteVisita,
  onEditEntry,
  onDeleteEntry,
  onUploadEntry,
  toDiaryEntryItem,
}: SiteInspectionsProps) {
  const hasVisitas = siteInspections.length > 0;

  if (!hasVisitas) {
    return (
      <EmptyVisitasState
        isAdmin={isAdmin}
        onAddFirstVisita={onAddFirstVisita}
        addVisitaLoading={addVisitaLoading}
      />
    );
  }

  return (
    <div className="space-y-10">
      {siteInspections.map((visita) => (
        <SiteInspectionSection
          key={visita.id}
          visita={visita}
          entriesAsItems={visita.diaryEntries.map(toDiaryEntryItem)}
          currentUserId={currentUserId}
          isAdmin={isAdmin}
          projectId={projectId}
          onFileVisibilityChange={onFileVisibilityChange}
          onAddEntry={onAddEntry}
          onDeleteVisita={onDeleteVisita}
          onEditEntry={onEditEntry}
          onDeleteEntry={onDeleteEntry}
          onUploadEntry={onUploadEntry}
        />
      ))}
      {hasNextPage && onLoadMore && (
        <div className="flex justify-center pt-4">
          <button
            type="button"
            onClick={onLoadMore}
            className="border border-primary-200 dark:border-primary-800 text-primary-950 dark:text-white px-6 py-2 text-sm uppercase tracking-widest font-light hover:border-primary-400 dark:hover:border-primary-600 transition-colors duration-300 cursor-pointer"
          >
            CARREGAR MAIS VISTAS
          </button>
        </div>
      )}
    </div>
  );
}
